// 测试 JCB 会员用户
const JCB_MEMBER_USERS = [
  "U0532108261", // caohui, sg
  "U0812104574", // caohui, jp
  "U0532105756", // linna, sg
  "U0812307662", // beryl, jp
  "U0322102118", //caohui dev jp
  "U0262202049", //caohui dev sg
  "U0262509279", // lilu dev sg
  "U0322509462", //lilu dev jp
  "U0532306048", // jojo sg
  "U0532503129", // kiko sg
  "U0532413214", // ivan sg
  "U0532307124", // yuki sg
  "U0812538375" // vincy, jp
];

/**
 * 判断用户是否为 JCB 会员
 * @param user 用户对象
 * @param isTheClass 是否需要判断TheClass
 * @returns {boolean} 是否为 JCB 会员
 */
export const isJcbMember = (user, isTheClass = false) => {
  if (isTheClass) {
    return (
      (user?.loyaltyProgram?.coBrandedCard?.issuer === "jcb" &&
        user?.loyaltyProgram?.coBrandedCard?.tier === "TheClass") ||
      JCB_MEMBER_USERS.includes(user?.no)
    );
  }
  return (
    user?.loyaltyProgram?.coBrandedCard?.issuer === "jcb" ||
    JCB_MEMBER_USERS.includes(user?.no)
  );
};
